import React from 'react'
import { Helmet } from 'react-helmet'
import { useIntl } from 'react-intl'
import { TITLE_PAGES_BY_LANGUAGE } from './constants';

const SEO = () => {
  const intl = useIntl();

  // Define the regular expressions for matching specific paths
  const pageTitle = /\/projects/.test(window.location.pathname) || /\/project/.test(window.location.pathname)
    ? TITLE_PAGES_BY_LANGUAGE.projectsLibrary[intl.locale]
    : TITLE_PAGES_BY_LANGUAGE.productsLibrary[intl.locale];

  return (
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
  );
}

export default SEO
